/**
 * Naive client-side cooldown for the "Oppdater skolekundestatus" button.
 *
 * Refreshing school approval triggers a Crystallize lookup and a Clerk metadata
 * write, so we throttle how often a user can trigger it. The cooldown is stored
 * in `localStorage` keyed per active school org number and is intentionally
 * simple: clearing storage resets it. It only smooths accidental spamming, it is
 * not a security control.
 */
export const COOLDOWN_MS = 5 * 60 * 1000;

const STORAGE_PREFIX = "schoolApprovalRefresh";

export const cooldownStorageKey = (orgNumber: string): string =>
  `${STORAGE_PREFIX}:${orgNumber}`;

/**
 * Returns the remaining cooldown in milliseconds given the last run timestamp.
 * A missing, non-finite, or future `lastRunAt` yields `0` (no cooldown), so a
 * cleared or corrupted value simply re-enables the button.
 */
export const getRemainingCooldownMs = (
  lastRunAt: number | null | undefined,
  now: number,
  cooldownMs: number = COOLDOWN_MS,
): number => {
  if (lastRunAt == null || !Number.isFinite(lastRunAt) || lastRunAt > now) {
    return 0;
  }

  const remaining = cooldownMs - (now - lastRunAt);
  return remaining > 0 ? remaining : 0;
};
